import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex animate-fade-up flex-col gap-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-400">
            <span className="h-1 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm leading-relaxed text-foreground-500 md:text-base">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}